export enum PackageAddonSelectionType {
    Limited = 'Limited',
    RequiredLimited = 'Required Limited',
    Full = 'Full',
    RequiredFull = 'Required Full',
}
